class AppConfig {
  private readonly requiredVars: string[] = ['NEXT_PUBLIC_API_URL'];
  public readonly API_URL: string;
  public readonly REVALIDATE: number;
  private readonly DEFAULT_REVALIDATE = 600;

  constructor() {
    /**
     * Валидация только на стороне сервера
     */
    if (typeof window === 'undefined') {
      this.validateRequiredVariables();
    }

    this.API_URL = (process.env.NEXT_PUBLIC_API_URL as string) + '/api';

    const revalidateEnv = process.env.REVALIDATE;
    this.REVALIDATE = revalidateEnv ? Number(revalidateEnv) : this.DEFAULT_REVALIDATE;
  }

  private validateRequiredVariables(): void {
    const missingVars: string[] = [];
    for (const key of this.requiredVars) {
      if (!process.env[key]) {
        missingVars.push(key);
      }
    }

    if (missingVars.length > 0) {
      throw new Error(`Не указаны следующие ENV: ${missingVars.join(', ')}`);
    }
  }
}

const config = new AppConfig();

export default config;
